import React, { FC } from 'react';
import { Badge, Row, Typography } from 'components';
import styles from './styles.module.scss';
import { PurchaseRequestStatusType } from 'models/PurchaseRequest';

const { Text } = Typography;
type StatusMapType = {
  label: string;
  color: string;
  dotColor: string;
};
export const PURCHASE_REQUEST_STATUS_MAPPING: Record<PurchaseRequestStatusType, StatusMapType> = {
  SOURCING: {
    label: 'Sourcing',
    color: '#FEE0FF',
    dotColor: '#FF47E0',
  },
  CALCULATING: {
    label: 'Calculating',
    color: '#E0F7FF',
    dotColor: '#15C1FF',
  },
  NEW: {
    label: 'New',
    color: '#E6F0FF',
    dotColor: '#0D6EFD',
  },
  SOURCED: {
    label: 'Sourced',
    color: '#E4E2FF',
    dotColor: '#5647FF',
  },
  PRICE_CONFIRMATION_REQUESTED: {
    label: 'Price Confirmation Requested',
    color: '#FFEDDC',
    dotColor: '#FF9865',
  },
  CONFIRMING_PRICE: {
    label: 'Confirming Price',
    color: '#EEEFFF',
    dotColor: '#5865F2',
  },
  PRICE_CONFIRMED: {
    label: 'Price Confirmed',
    color: '#E3F4EE',
    dotColor: '#05796B',
  },
};

interface IStatusBadge {
  tooltip?: string;
  type: PurchaseRequestStatusType;
}

export const PurchaseRequestStatusBadge: FC<IStatusBadge> = React.memo((props) => {
  const { type } = props;
  const status = PURCHASE_REQUEST_STATUS_MAPPING[type as PurchaseRequestStatusType];
  return (
    <Row
      className={styles.badge}
      style={{ border: 'none', color: status.dotColor, backgroundColor: status.color }}
      align={'middle'}
    >
      <Badge color={status.dotColor} />
      <Text style={{ color: status.dotColor, fontSize: 12, fontWeight: 500 }}>{status.label}</Text>
    </Row>
  );
});
